/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import { ProgressBar, InputGroup, Form, Media, FormGroup, FormControl, ControlLabel, Glyphicon, Label, Button, Panel, ListGroup, ListGroupItem, Grid, Row, Col, Image} from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import ReactSpinner from 'react-spinjs';
import ProductEditView from '../products/ProductEditView.react';
import DataHelper from '../../library/DataHelpers';
import ProductStore from '../../stores/ProductStore';
import JobHistorySelector from './jobHistorySelector';
import APIActions from '../../actions/apiActions';
import JobStore from '../../stores/JobStore';
import JobOverviewItem from "./jobOverviewItem";
import JobAPI from "../../api/awsJobAPI";


export default class JobStatusGridList extends React.Component {
    constructor(props) {
        console.log("[JobStatusView] - initialisation");
        super(props);

        this.handleHistorySelection = this.handleHistorySelection.bind(this);
        this.moveToJobState = this.moveToJobState.bind(this);
        this.loadHistory = this.loadHistory.bind(this);
        this.showLatest = this.showLatest.bind(this);
        this._onJobChange = this._onJobChange.bind(this);

        this.state = {
            selectedGroup : null,
            pins : [],
            pinStatus : {},
            product : null,
            groups : [],
            groupPins : {},
            pinValues : {},
            timestamp : null,
            loadingHistory : false,
            dateSummary : [],
            historySummary : {ok: [], warn: [], error: []},
            history: {earliest:null, latest:null}
        }
    }

    componentWillReceiveProps(np) {
        if (!np.job) {
            return ;
        }

        let pid = np.job.productId ;
        var s = this.state ;
        s.product = ProductStore.productForId(pid);
        s.groups = this.buildPinGroupingSet(s.product);
        s.groupPins = this.buildPinStatusList(s.groups,s.product) ;
        s.pinValues = np.job.state ?
            this.buildPinStatusValues(np.job.state.status, np.job.state.mode)
            : {};

        if (np.job.state && np.job.state.status && np.job.state.status.ts) {
            s.timestamp = moment.utc(np.job.state.status.ts, 'YYYYMMDDHHmmss').local().format("MM/DD/YYYY HH:mm");
        }
        else {
            s.timestamp = undefined ;
        }

        console.log("[JobStatusView] - state=", np.job.state);
        this.setState(s);
    }

    componentDidMount() {
        console.log("[JobHistorySelector] - componentDidMount");
        JobStore.addChangeListener(this._onJobChange) ;
    }

    componentWillUnmount() {
        console.log("[JobHistorySelector] - componentWillUnmount");
        JobStore.removeChangeListener(this._onJobChange);
    }

    _onJobChange() {
        if (this.state.loadingHistory) {
            this.setState({loadingHistory:false});
        }
    }

    moveToJobState(state,mode,time) {
        console.log("[JobStatusView] - moving to state: ", state, mode, time);
        var s = this.state ;
        s.pinValues = this.buildPinStatusValues(state, mode);
        s.timestamp = moment.utc(time, 'YYYYMMDDHHmmss').local().format("MM/DD/YYYY HH:mm");
        this.setState(s);
    }

    buildPinGroupingSet(product) {
        if (!product || !product.pins) {
            return [];
        }

        var groupSet = {};
        product.pins.forEach(function(e) {
            if (!e.pinGroup || e.pinGroup === "") {
                // if (!groupSet["unassigned"]) {
                //     groupSet["unassigned"] = {name: "unassigned", errors: 0, warnings: 0} ;
                // }
            }
            else if (!e.pinGroup.includes(",")) {
                if (!groupSet[e.pinGroup.trim()]) {
                    groupSet[e.pinGroup.trim()] = {name: e.pinGroup.trim(), errors: 0, warnings: 0} ;
                }
            }
            else {
                e.pinGroup.split(',').forEach((p) => {
                    if (!groupSet[p.trim()]) {
                        groupSet[p.trim()] = {name: e.pinGroup.trim(), errors: 0, warnings: 0} ;
                    }
                });
            }
        });

        let r = Object.keys(groupSet).map((k) => {return k});
        r.sort();
        return r ;
    }

    pinSort(pins,grp) {
        pins.sort((a,b) => {
            if (a.order && b.order && (a.order[grp] !== undefined) && (b.order[grp] !== undefined)) {
                var v1 = a.order[grp];
                var v2 = b.order[grp];
                if (v1 < v2) {
                    return -1 ;
                }
                else if (v1 === v2) {
                    return 0 ;
                }
                else {
                    return 1 ;
                }
            }
            else if (a.order && a.order[grp] !== undefined) {
                return -1 ;
            }
            else {
                return 1 ;
            }
        });

        return pins ;
    }

    buildPinStatusList(groups,product) {
        if (!product || !product.pins) {
            return {};
        }

        let groupPins = {} ;
        for (let ix = 0 ; ix < groups.length ; ix++) {
            let grp = groups[ix];
            let pins = [];
            product.pins.forEach(function(e) {
                if (!e.pinGroup || e.pinGroup === "") {
                    if (grp === "unassigned") {
                        pins.push(e);
                    }
                }
                else if (e.pinGroup.trim().includes(grp.trim())) {
                    pins.push(e);
                }
            });

            groupPins[grp] = this.pinSort(pins,grp) ;
        }

        return groupPins;
    }

    buildPinStatusValues(jobState,pinMode) {
        /*
            "raw" : {
                "mode" : 128,
                "hardware" : "v1-01",
                "firmware" : "v0-13",
                "mac" : "00-1e-c0-14-32-cf",
                "input" : [64,24,158],
                "output" : [0,64,0],
                "trip" : "2338",
                "pot"  : "03020",
                "client" : "Savaria SIS"
            }
        */

        var status = {};

        // console.log("[PINS] jobState=", jobState);
        if (!jobState) {
            return status ;
        }

        var mode = parseInt(pinMode) ;
        if (isNaN(mode) || mode < 0) {
            return status ;
        }
        else if (mode < 64) {
            /*
                    var stateRow = {
                    ts  : workflow.message.timeUtc,
                    in  : [in0,in1,in2,in3,in4,in5,in6,in7] ,
                    v0  : workflow.packet.row.v0 || "?" ,
                    v1  : workflow.packet.row.v1 || "?",
                    st  : "?"
                };
            */
            let js = jobState ;
            status.in0 = js.in ? js.in[0] : "-";
            status.in1 = js.in ? js.in[1] : "-";
            status.in2 = js.in ? js.in[2] : "-";
            status.in3 = js.in ? js.in[3] : "-";
            status.in4 = js.in ? js.in[4] : "-";
            status.in5 = js.in ? js.in[5] : "-";
            status.in6 = js.in ? js.in[6] : "-";
            status.in7 = js.in ? js.in[7] : "-";
            status.v0 = js.v0 ;
            status.v1 = js.v1 ;
        }
        else if (mode < 128) {

            let js = jobState ;
            status.v0 = js.v0 ;
            status.v1 = js.v1 ;

            status.ain0 = js.in ? js.in[0] : "-";
            status.ain1 = js.in ? js.in[1] : "-";
            status.ain2 = js.in ? js.in[2] : "-";
            status.ain3 = js.in ? js.in[3] : "-";
            status.ain4 = js.in ? js.in[4] : "-";
            status.ain5 = js.in ? js.in[5] : "-";
            status.ain6 = js.in ? js.in[6] : "-";
            status.ain7 = js.in ? js.in[7] : "-";
            status.ain8 = js.in ? js.in[8] : "-";
            status.ain9 = js.in ? js.in[9] : "-";
            status.ain10 = js.in ? js.in[10] : "-";
            status.ain11 = js.in ? js.in[11] : "-";
            status.ain12 = js.in ? js.in[12] : "-";
            status.ain13 = js.in ? js.in[13] : "-";
            status.ain14 = js.in ? js.in[14] : "-";
            status.ain15 = js.in ? js.in[15] : "-";
            status.ain16 = js.in ? js.in[16] : "-";
            status.ain17 = js.in ? js.in[17] : "-";

            status.dip0 = js.dip[0];
            status.dip1 = js.dip[1];
            status.dip2 = js.dip[2];
            status.dip3 = js.dip[3];
            status.dip4 = js.dip[4];
            status.dip5 = js.dip[5];
        }
        else {
            let js = jobState ;

            status.i0 = js.in ? js.in[0] : "-";
            status.i1 = js.in ? js.in[1] : "-";
            status.i2 = js.in ? js.in[2] : "-";
            status.i3 = js.in ? js.in[3] : "-";
            status.i4 = js.in ? js.in[4] : "-";
            status.i5 = js.in ? js.in[5] : "-";
            status.i6 = js.in ? js.in[6] : "-";
            status.i7 = js.in ? js.in[7] : "-";
            status.i8 = js.in ? js.in[8] : "-";
            status.i9 = js.in ? js.in[9] : "-";
            status.i10 = js.in ? js.in[10] : "-";
            status.i11 = js.in ? js.in[11] : "-";
            status.i12 = js.in ? js.in[12] : "-";
            status.i13 = js.in ? js.in[13] : "-";
            status.i14 = js.in ? js.in[14] : "-";
            status.i15 = js.in ? js.in[15] : "-";
            status.i16 = js.in ? js.in[16] : "-";
            status.i17 = js.in ? js.in[17] : "-";
            status.i18 = js.in ? js.in[18] : "-";
            status.i19 = js.in ? js.in[19] : "-";
            status.i20 = js.in ? js.in[20] : "-";
            status.i21 = js.in ? js.in[21] : "-";
            status.i22 = js.in ? js.in[22] : "-";
            status.i23 = js.in ? js.in[23] : "-";

            status.o0 = js.out ? js.out[0] : "-";
            status.o1 = js.out ? js.out[1] : "-";
            status.o2 = js.out ? js.out[2] : "-";
            status.o3 = js.out ? js.out[3] : "-";
            status.o4 = js.out ? js.out[4] : "-";
            status.o5 = js.out ? js.out[5] : "-";
            status.o6 = js.out ? js.out[6] : "-";
            status.o7 = js.out ? js.out[7] : "-";
            status.o8 = js.out ? js.out[8] : "-";
            status.o9 = js.out ? js.out[9] : "-";
            status.o10 = js.out ? js.out[10] : "-";
            status.o11 = js.out ? js.out[11] : "-";
            status.o12 = js.out ? js.out[12] : "-";
            status.o13 = js.out ? js.out[13] : "-";
            status.o14 = js.out ? js.out[14] : "-";
            status.o15 = js.out ? js.out[15] : "-";
            status.o16 = js.out ? js.out[16] : "-";
            status.o17 = js.out ? js.out[17] : "-";
            status.o18 = js.out ? js.out[18] : "-";
            status.o19 = js.out ? js.out[19] : "-";
            status.o20 = js.out ? js.out[20] : "-";
            status.o21 = js.out ? js.out[21] : "-";
            status.o22 = js.out ? js.out[22] : "-";
            status.o23 = js.out ? js.out[23] : "-";
        }

        console.log("[PINS] job (status)=", status);
        return status ;
    }

    ledForPinStatus(status,pin) {
        var on = (pin.zeroOn || false) ? (status === 0 || status === "0" || status === "on") : (status === 1 || status === "1" || status === "on") ;
        if (on) {
            switch (pin.led) {
                case "R" : return <div className="pinLedRed pinLarge"/> ;
                case "G" : return <div className="pinLedGreen pinLarge"/> ;
                case "Y" : return <div className="pinLedYellow pinLarge"/> ;
                case "O" : return <div className="pinLedOrange pinLarge"/>;
                default  : return <div className="pinLedOff pinLarge"/> ;
            }
        }
        else if (status === "-") {
            return <div className="pinLedMissingData pinLarge"/> ;
        }
        else {
            return <div className="pinLedOff pinLarge"/> ;
        }
    }

    dipValue(status) {
        var on = status === "1" || status === "on" ;
        if (on) {
            return "ON";
        }
        else {
            return "OFF" ;
        }
    }


    handleHistorySelection(history,mode) {
        console.log("[JobStatusView] - history select: ", history, mode);
        if (history) {
            this.moveToJobState(history.status,mode,history.ts);
        }
    }

    async loadHistory() {
        if (this.props.job && this.props.job.jobnum) {
            this.setState({loadingHistory:true});
            //  setTimeout(() => {
            //     APIActions.jobHistorySummary(this.props.job.jobId);
            // }, 250) ;

             //historySummary = {ok: [], warn: [], error: []}

            setTimeout(async () => {
                let hs = await JobAPI.getJobHistorySummaryV2(this.props.job.jobId) ;
                if (!hs || hs.status !== 200) {
                    console.error("Problem loading Job Date History") ;
                    this.setState({loadingHistory:false});
                }
                else {
                    let dates = hs.data ;
                    console.log("Loaded Date History: ", dates) ;

                    let history = {
                        earliest : null,
                        latest : null
                    };

                    let summary = dates.reduce((a,d) => {
                        let ud = moment.utc(d.reading_date);
                        let rd = new Date(ud.year(), ud.month(), ud.date());
                        if (d.critical > 0) {
                            a.error.push(rd) ;
                        }
                        else if (d.safety > 0) {
                            a.warn.push(rd) ;
                        }
                        else{
                            a.ok.push(rd) ;
                        }

                        let ed = moment.utc(d.earliest);
                        let ld = moment.utc(d.latest);
                        if (!history.earliest || ed.isBefore(history.earliest)) {
                            history.earliest = ed ;
                        }

                        if (!history.latest || ld.isAfter(history.latest)) {
                            history.latest = ld ;
                        }
                        return a ;
                    }, {ok: [], warn: [], error: []});

                    if (history.earliest) {
                        history.earliest = moment.utc(history.earliest, 'YYYYMMDDHHmmss').local().format('YYYY-MM-DD HH:mm:ss');
                    }

                    if (history.latest) {
                        history.latest = moment.utc(history.latest, 'YYYYMMDDHHmmss').local().format('YYYY-MM-DD HH:mm:ss');
                    }

                    // console.log("History History: ", history) ;
                    // console.log("History Summary: ", summary) ;
                    this.setState({loadingHistory:false, dateSummary : dates, historySummary : summary, history: history});
                }
            }, 150) ;
        }
    }

    showLatest() {
        console.log("[JobStatusView] - show latest: ",this.props.job.state.status,this.props.job.state.mode,this.props.job.state.status.ts);
        this.moveToJobState(this.props.job.state.status,this.props.job.state.mode,this.props.job.state.status.ts);
    }

    render() {
        let productName = this.state.product ? this.state.product.name : "'loading'";
        let pinGroups = this.state.groups || [];
        var self = this ;
        let numRows = Math.floor(pinGroups.length / 3) + ((pinGroups.length % 3) > 0 ? 1 : 0);
        let rows = [];
        for (let r = 0 ; r < numRows; r++) {
            rows.push(r);
        }

        const spinOpts = {
              lines: 13, // The number of lines to draw
              length: 12, // The length of each line
              width: 4, // The line thickness
              radius: 25, // The radius of the inner circle
              scale: 1, // Scales overall size of the spinner
              corners: 1, // Corner roundness (0..1)
              speed: 1, // Rounds per second
              rotate: 0, // The rotation offset
              animation: 'spinner-line-fade-quick', // The CSS animation name for the lines
              direction: 1, // 1: clockwise, -1: counterclockwise
              color: 'blue', // CSS color or array of colors
              fadeColor: 'transparent', // CSS color or array of colors
              top: '40px', // Top position relative to parent
              left: '50%', // Left position relative to parent
              shadow: '0 0 1px transparent', // Box-shadow for the lines
              zIndex: 2000000000, // The z-index (defaults to 2e9)
              className: 'spinner', // The CSS class to assign to the spinner
              position: 'relative', // Element positioning
            };

        return (
                <Grid fill>
                     <Row>
                        <Col>
                            <Button onClick={this.loadHistory} disabled={!this.props.editable} bsStyle="success" ><Glyphicon glyph="calendar"/>{' '}Load History</Button>
                            <Button onClick={this.showLatest} disabled={!this.props.editable} bsStyle="success" ><Glyphicon glyph="star"/>{' '}Show Latest</Button>
                       </Col>
                    </Row>
                    <Row hidden={!this.state.loadingHistory}>
                        <Col>
                            <div className="load-banner">
                                <h3>Please wait... Loading History</h3>
                                <ReactSpinner  config={spinOpts}/>
                            </div>
                        </Col>
                    </Row>
                    <Row >
                        <Col>
                            <JobHistorySelector
                                job={this.props.job}
                                startDate={this.state.history.earliest}
                                endDate={this.state.history.latest}
                                historyDates={this.state.dateSummary}
                                historySummary={this.state.historySummary}
                                historySelected={this.handleHistorySelection}/>
                        </Col>
                    </Row>
                     <Row>
                        <Col>
                            <h3>Showing data at {this.state.timestamp || "N/A"}</h3>
                        </Col>
                    </Row>
                    <div className="container">
                        {rows.map((row) => {
                            let rowData = pinGroups.slice((row * 3), (row * 3) + 3) ;
                            return (
                                <div className="row" style={{marginBottom: '50px'}} >
                                    {rowData.map((pg) => {
                                        let pins = self.state.groupPins[pg] || [];
                                        return (
                                            <Col key={pg} md={4}>
                                                <div className="pinStatusView">
                                                    <h3>{pg}</h3>
                                                    {pins.map((pin) => {
                                                        let k = pg + ":" + pin.title;
                                                        var v = self.state.pinValues[pin.channel] ;
                                                        if (v === null || v === undefined) {
                                                            v = 0;
                                                        }

                                                        switch (pin.type) {
                                                            case "voltage" :
                                                                return (
                                                                    <Grid>
                                                                        <Row className="show-grid"  key={k}>
                                                                            <Col md={1}><div className="pinVoltage">{v}</div></Col>
                                                                            <Col md={2}><h4>{pin.title}</h4><small>{pin.desc}</small></Col>
                                                                        </Row>
                                                                    </Grid>
                                                                );
                                                            case "dip" :
                                                                let dip = self.dipValue(v);
                                                                return (
                                                                    <Grid>
                                                                        <Row className="show-grid"  key={k}>
                                                                            <Col md={1}><div className="pinDip">{dip}</div></Col>
                                                                            <Col md={2}><h4>{pin.title}</h4><small>{pin.desc}</small></Col>
                                                                        </Row>
                                                                    </Grid>
                                                                );
                                                            default :
                                                                let led = self.ledForPinStatus(v,pin);
                                                                return (
                                                                    <Grid>
                                                                        <Row className="show-grid"  key={k}>
                                                                            <Col md={1}>{led}</Col>
                                                                            <Col md={2}><h4>{pin.title}</h4><p><small>{pin.desc}</small></p></Col>
                                                                        </Row>
                                                                    </Grid>
                                                                );
                                                        }

                                                    })}
                                                </div>
                                            </Col>
                                        );
                                    })}
                                </div>
                            )
                        })
                        }

                    </div>

                    <Row >
                        <Col>
                            <br/><br/><br/>
                        </Col>
                    </Row>
                </Grid>
            );

    }
}




// WEBPACK FOOTER //
// ./src/app/components/jobs/jobStatusGridList.js